(function($){
    function novotel_miami_initializeMapGroup(div){
        if (typeof(div) === "undefined") div = "map-canvas";
        if (typeof(bounds) === "undefined" && map_config.set_bounds) bounds = new google.maps.LatLngBounds();

        var marker, i;
        center = [map_config.markers[0].latitude, map_config.markers[0].longitude];

        map = new google.maps.Map(document.getElementById(div), {
            // scroll wheel
            scrollwheel: false,
            //zoom
            zoom: map_config.map_zoom,
            zoomControlOptions: {
                position: google.maps.ControlPosition[map_config.zoom_control_position]
            },
            //position
            center: new google.maps.LatLng(center[0], center[1]),
            //map type
            mapTypeId: google.maps.MapTypeId[map_config.map_type],
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
                style: google.maps.MapTypeControlStyle.DEFAULT
            },
            panControl: false,
            panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            scaleControl: false,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            }

        });

        var styles = [{"featureType": "administrative.province", "elementType": "all", "stylers": [{"visibility": "off"}]}, {"featureType": "landscape", "elementType": "all", "stylers": [{"saturation": -100}, {"lightness": 60}]}, {"featureType": "poi.business", "elementType": "all", "stylers": [{"visibility": "off"}]}, {"featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{"color": "#b6c54c"}, {"lightness": 40}, {"saturation": -40}]}, {"featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{"color": "#ef8c25"}, {"lightness": 40}]}, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"visibility": "off"}]}, {"featureType": "road.local", "elementType": "all", "stylers": [{"saturation": -100}, {"lightness": 40}, {"visibility": "on"}]}, {"featureType": "transit", "elementType": "all", "stylers": [{"saturation": -100}, {"visibility": "simplified"}]}, {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{"visibility": "on"}, {"lightness": 30}]
        }];

        map.setOptions({styles: styles});

        for (i = 0; i < map_config.markers.length; i++) {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(map_config.markers[i].latitude, map_config.markers[i].longitude),
                map: map,
                icon: map_config.markers[i].icon_hotel,
                id_poi: map_config.markers[i].id_poi.toString(),
                poi_title: map_config.markers[i].title.toString(),
                destination: map_config.markers[i].destination.toString(),
                zIndex: 99,
                visible: true
            });

            markers[map_config.markers[i].id_poi] = marker;

            bounds.extend(marker.position);

            $('div[id^=poi-]').css('z-index', 1);
            $('#poi-hotel').css('z-index', 99);

            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    for (i = 1; i < map_config.markers.length; i++) {
                        // markers[i].setIcon(map_config.icon_small);
                        markers[map_config.markers[i].id_poi].setIcon(map_config.icon_small);
                    }

                    map.setCenter(marker.getPosition());
                    if(marker.id_poi !== 'hotel'){
                        marker.setIcon(map_config.icon_zoomed);
                    }

                    $('div[id^=poi-]').css('z-index', 1);
                    $('#poi-'+ marker.id_poi).css('z-index', 99);

                    window.__last_clicked_poi = marker.poi_title;
                    $('.map-canvas').trigger('click_on_single_poi');

                    //focusable element
                    $('div[id^="poi-"] a').attr('tabindex', '-1');
                    $('#poi-'+ marker.id_poi + ' a').attr('tabindex', '0');

                    // if(marker.id_poi === 'hotel'){
                    //     $('#poi-hotel a:first').focus();
                    //     $('#poi-hotel a:last').focusout(function () {
                    //         marker.focus();
                    //     });
                    // } else {
                    //     var close_poi = $('#poi-'+ marker.id_poi + ' .close_poi');
                    //     close_poi.focus();
                    //     $('#poi-'+ marker.id_poi + ' a:last').focusout(function () {
                    //         close_poi.focus();
                    //         close_poi.keydown(function (eve) {
                    //             if (eve.which == 13) {
                    //                 marker.focus();
                    //             }
                    //         });
                    //     });
                    //
                    // }

                    // $('html, body').on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
                    //     $('html, body').stop();
                    // });
                    //
                    // $('html, body').animate({ scrollTop: $('#map-canvas').offset().top - 90}, 'fast', function(){
                    //     $('html, body').off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
                    // });

                    // $('html, body').animate({
                    //     scrollTop: $('#map-canvas').offset().top - 90
                    // }, 200);


                    if($(window).width() < 828){
                        $('div[id^="poi-"] ').css('opacity', '0');
                        $('#poi-' + marker.id_poi ).css('opacity', '1');
                        $('.map-canvas').css('margin-bottom', $('#poi-' + marker.id_poi ).height() + 30);
                    }
                };
            })(marker, i));
        }

        // map.fitBounds(bounds,{top: 50, right: 30, bottom: 150, left: 30 });

        if(!($(window).width() < 828)){
            map.fitBounds(bounds,{top: 50, right: 30, bottom: 150, left: 30 });
        } else {
            map.fitBounds(bounds,{top: 20, right: 20, bottom: 30, left: 20 });
        }
        var listener = google.maps.event.addListener(map, "idle", function() {
            if (map.getZoom() > 16) map.setZoom(16);
            google.maps.event.removeListener(listener);
        });


        //filters makers
        var filters_maps_button = $('.single_filter_container a');
        filters_maps_button.click(function(){
            var category = $(this).data('category');
            $('.single_filter_container a').removeClass('active');
            $(this).addClass('active');


            $('div[id^=poi-]').css('z-index', 1);
            $('#poi-hotel').css('z-index', 99);

            for (i = 1; i < map_config.markers.length; i++) {
                markers[map_config.markers[i].id_poi].setIcon(map_config.icon_small);
            }

            novotel_miami_filterMarkers(category);
        });

        var filters_maps_select = $('.map-pois #select_filter');
        filters_maps_select.change(function(){
            var category = $(this).val();

            $('div[id^=poi-]').css('z-index', 1);
            $('#poi-hotel').css('z-index', 99);

            for (i = 1; i < map_config.markers.length; i++) {
                markers[map_config.markers[i].id_poi].setIcon(map_config.icon_small);
            }

            novotel_miami_filterMarkers(category);
        });


        $('.close_poi').click(function(){
            $('div[id^=poi-]').css('z-index', 1);
            $('#poi-hotel').css('z-index', 99);

            for (i = 1; i < map_config.markers.length; i++) {
                markers[map_config.markers[i].id_poi].setIcon(map_config.icon_small);
            }
            if(!($(window).width() < 828)){
                map.fitBounds(bounds,{top: 50, right: 30, bottom: 150, left: 30 });
            } else {
                map.fitBounds(bounds,{top: 20, right: 20, bottom: 30, left: 20 });
            }
            // map.fitBounds(bounds,{top: 50, right: 30, bottom: 150, left: 30 });
            var listener = google.maps.event.addListener(map, "idle", function() {
                if (map.getZoom() > 16) map.setZoom(16);
                google.maps.event.removeListener(listener);
            });

            if($(window).width() < 828){
                $('div[id^="poi-"] ').css('opacity', '0');
                $('#poi-hotel').css('opacity', '1');
                $('.map-canvas').css('margin-bottom', $('#poi-hotel').height() + 30);
            }

        });


        if($(window).width() < 828){
            novotel_miami_filterMarkers('.hotel');
        }

    }

    function novotel_miami_filterMarkers(category){
        showMarkers(category);
    }


    // Sets the map on all markers in the array.
    function setMapOnAll(category, bounds) {
        Object.keys(markers).forEach(function(i){
            var marker = markers[i];
            if (marker.destination.includes(category)) {
                marker.setMap(map);
                bounds.extend(marker.position);
                $('.focusable_poi[data-poi="'+ marker.id_poi +'"]').show();
            } else {
                marker.setMap(null);

                $('.focusable_poi[data-poi="'+ marker.id_poi +'"]').hide();
            }
        });

        // map.fitBounds(bounds,{top: 50, right: 30, bottom: 150, left: 30 });
        if(!($(window).width() < 828)){
            map.fitBounds(bounds,{top: 50, right: 30, bottom: 150, left: 30 });
        } else {
            map.fitBounds(bounds,{top: 20, right: 20, bottom: 30, left: 20 });
        }

    }

// Removes the markers from the map, but keeps them in the array.
    function hideMarkers() {
        Object.keys(markers).forEach(function(i){
            markers[i].setMap(null);
        });
        $('.focusable_poi').hide();
    }

// Shows any markers currently in the array.
    function showMarkers(category) {
        hideMarkers();
        setMapOnAll(category, bounds);
    }


    $(document).ready(function () {

        var map_loaded = false;
        if ($('#map-canvas').length === 0) return false;

        var position_map = $('.map-pois').offset().top - $('.map-pois').height() - 200;
        $(window).on("scroll", function() {
            var scrollPosition = window.pageYOffset;
            if(!map_loaded && scrollPosition >= position_map){
                map_loaded = true;
                novotel_miami_initializeMapGroup();

                setTimeout(function(){
                    $('#map-canvas button, #map-canvas a').attr('tabindex', '-1');
                }, 2500);
            }
        });




        setTimeout(function () {
            var $poi_box = $('.poi_description_container'),
                highestBox = 0;

            $poi_box.each(function (){
                var box_H = $(this);
                if(box_H.height() > highestBox) {
                    highestBox = box_H.height();
                }
            });

            if(!($(window).width() < 828)){
                $poi_box.height(highestBox);
                $('.map-canvas').css('margin-bottom',highestBox + 30);

                $('.container_focus_pois').css('margin-left', $('.filter-wrap .middle_title').outerWidth(true));

            } else {
                $('.map-canvas').css('margin-bottom', $('#poi-hotel').height() + 30);
            }


        }, 500);


    });

})(jQuery);